import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { USAepayPageRoutingModule } from './usaepay-routing.module';

import { USAepayPage } from './usaepay.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    USAepayPageRoutingModule,
  ],
  declarations: [USAepayPage],
})
export class USAepayPageModule {}
